import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { DataDocumentsSystemModel, DocumentsSystemModel }
from '../../models/configuration/documents-system.model';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class CreateDocumentSystemUseCase implements UseCase< DataDocumentsSystemModel, DocumentsSystemModel> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        params: DataDocumentsSystemModel
    ):
    Observable<DocumentsSystemModel> {
        return this.repository
            .createDocumentSystem(
                params
            );
    }
}